import { DocumentFieldValue } from "../../../components";
import { Airport } from "../../../core/flight-static-data";
import { JourneyType } from "../../../types/flight";
import { JavaCurrencyValue } from "../../../utils";
import { CrossSellProductAddOnInformation } from "./FlightPrebookCrossSellAddOns";

export type Gender = "M" | "F";
export type Honorific = "MR" | "MRS" | "MISS";
export type PassengerType = "ADULT" | "CHILD" | "INFANT";
export enum FlightPassengerDocumentType {
  NATIONAL_ID = "NATIONAL_ID",
  PASSPORT = "PASSPORT",
}

export type FlightPassengerAddOns = {
  departureAirport: Pick<Airport, "city" | "airportCode">;
  arrivalAirport: Pick<Airport, "city" | "airportCode">;
  journeys: BaggageAddOns | BaggageAddOns[];
};

export type BaggageAddOns = {
  id: string; // e.g. id cgk-dps-001
  baggageType: "PIECE" | "KG";
  baggageWeight: string;
  baggageQuantity: string;
  priceWithCurrency: JavaCurrencyValue;
  departureAirport: Pick<Airport, "city" | "airportCode">;
  arrivalAirport: Pick<Airport, "city" | "airportCode">;
  segmentInfo?: any; // we don't use this, only for data api
};

type PassengerBaseFormValue = {
  title: Honorific;
  gender: Gender;
  nationality: string;
  dateOfBirth?: Date | null;
  documentDetail: {
    documentNo?: string | null;
    documentType: FlightPassengerDocumentType;
    issuingCountry?: string | null;
    expirationDate?: Date | null;
  } | null;
};

export type AdultPassengerFormValue = PassengerBaseFormValue & {
  type: "ADULT";
  email?: string;
  fullname: string;
  addOns: FlightPassengerAddOns[][];
  isEmployee: boolean;
};

export type ChildPassengerFormValue = PassengerBaseFormValue & {
  type: "CHILD";
  fullname: string;
  addOns: FlightPassengerAddOns[][];
};

export type InfantPassengerFormValue = PassengerBaseFormValue & {
  type: "INFANT";
  fullname: string;
};

export type FlightPrebookFormValue = {
  departureDate: Date;
  contact: {
    fullname: string;
    email: string;
    phone: {
      phone: string;
      prefix: string;
    } | null;
  };
  passengers: {
    adults: AdultPassengerFormValue[];
    children?: ChildPassengerFormValue[];
    infants?: InfantPassengerFormValue[];
  };
  isTripDomesticID: boolean;
  flight: {
    flightIds: string[];
    airlineCodes: string[];
    journeyType: JourneyType;
    flightFare: {
      departure: {
        price: JavaCurrencyValue;
        productId: string;
        departureAirport: Pick<Airport, "city" | "airportCode">;
        arrivalAirport: Pick<Airport, "city" | "airportCode">;
      };
      arrival:
        | {
            price: JavaCurrencyValue;
            productId: string;
            departureAirport: Pick<Airport, "city" | "airportCode">;
            arrivalAirport: Pick<Airport, "city" | "airportCode">;
          }
        | undefined;
    };
  };
  additionalFees: {
    vatFee?: JavaCurrencyValue | null;
    whtFee?: JavaCurrencyValue | null;
    serviceFee?: JavaCurrencyValue | null;
  };
  grandTotal: JavaCurrencyValue | null;
  totalFareFromClient: JavaCurrencyValue;
  searchId: string | null;
  notes?: string;
  attachment?: DocumentFieldValue | null;
  addOnsBookingFormId?: string;
  policyBypassRemarks?: string;
  crossSellProductAddOns?: Record<string, CrossSellProductAddOnInformation>;
};

export type FlightPrebookAddOnsQuery = {
  data: {
    catalog: Record<string, BaggageAddOns[]>;
  } | null;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};
